// @ts-nocheck
// @ts-ignore
global.window = {
  require,
};
if (typeof window !== 'undefined') {
  window.require = require;
}
